import { SearchRegistry } from '../types';

export const dashboardSearchEntries: SearchRegistry = {
  '/': {
    keywords: [
      'home',
      'welcome',
      'dashboard',
      'landing',
      'main page',
      'start page',
      'entry page',
      'portal home',
      'startseite',
      'welcome to ryd portal',
      'welcome container',
      'account overview',
      'welcome screen',
      'getting started home',
    ],
    questions: [
      'Where is the home page?',
      'How do I get back to the portal landing page?',
      'What is shown on the welcome screen?',
    ],
  },
};
